import "./App.css";
import Login from "./components/login/Login";
import { Switch, Route, BrowserRouter } from "react-router-dom";
import ActionNotification from "./components/ui/ActionNotification";
import Spinner from "./components/ui/Spinner";
import PrivateRoute from "./util/PrivateRoute";
import Home from "./components/home/Home";
import VerifyOTP from "./components/verifyOtp/VerifyOtp";
import { SidebarProvider } from "./contexts/SidebarContext";
import React from 'react';


function App() {

  return (
    <div className="App">
      <BrowserRouter>
        <Switch>
          <Route exact path="/login" component={Login} />
          <Route exact path="/verify-otp" component={VerifyOTP} />
          <PrivateRoute path="/" component={() => (
            <SidebarProvider>
              <Home />
            </SidebarProvider>
          )} />
        </Switch>
      </BrowserRouter>
      <ActionNotification />
      <Spinner />
    </div>
  );
}

export default App;
